module.exports = __webpack_public_path__ + "img/product_sprycel_pic.78b36bc2.png";